import React from 'react';
import PropTypes from 'prop-types';
import HeroSection from './sections/HeroSection';
import PillarsSection from './sections/PillarsSection';
import OperatingLayersSection from './sections/OperatingLayersSection';
import PricingSection from './sections/PricingSection';
import SupportSection from './sections/SupportSection';
import LegacyFeaturesSection from './sections/LegacyFeaturesSection';
import LegacyExperienceSection from './sections/LegacyExperienceSection';
import LegacySupportSection from './sections/LegacySupportSection';
import LegacyCtaSection from './sections/LegacyCtaSection';

const SECTION_REGISTRY = {
  hero: HeroSection,
  pillars: PillarsSection,
  operating_layers: OperatingLayersSection,
  pricing: PricingSection,
  support: SupportSection,
  legacy_features: LegacyFeaturesSection,
  legacy_experience: LegacyExperienceSection,
  legacy_support: LegacySupportSection,
  cta: LegacyCtaSection,
};

const CmsPageRenderer = ({ config }) => {
  const sections = config?.sections || [];

  return (
    <>
      {sections.map((section) => {
        const Component = SECTION_REGISTRY[section.type];
        if (!Component) return null;
        return <Component key={section.id || section.type} {...(section.props || {})} />;
      })}
    </>
  );
};

CmsPageRenderer.propTypes = {
  config: PropTypes.shape({
    sections: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        type: PropTypes.string.isRequired,
        props: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
      })
    ),
  }),
};

CmsPageRenderer.defaultProps = {
  config: { sections: [] },
};

export default CmsPageRenderer;
